import { useAccountInfo } from '../provider/ModalContext';

export function useAccount(): string | undefined {
    const { account } = useAccountInfo();
    return account;
}
